import { createModule } from 'vuex-toast'

const toast = createModule()

export const state = () => ({ ...toast.state })

export const getters = toast.getters
export const actions = toast.actions
export const mutations = toast.mutations
